import { Dimensions, Platform } from "react-native";
import StyleSheet from "react-native-media-query";
import { theme } from "../../theme/theme";
import { isTablet } from "react-native-device-info";

// Define your styles
export const { ids, styles } = StyleSheet.create({
  successContainer: {
    position: "absolute",
    height: "100%",
    width: "100%",
  },
  formContainer: {
    paddingHorizontal: theme.spacing.cs,
  },
  gradientBg: {
    ...Platform.select({
      web: {
        backgroundImage: theme.colors.backgroundGradient,
      },
    }),
  },
  mainContainer: {
    flex: 1,
    height: "100%",
    width: "100%",
    ...Platform.select({
      ios: {
        marginTop: 100,
      },
      android: {
        marginTop: 100,
      },
      web: {
        height: "100%",
        width: "100%",
      },
    }),
  },
  container: {
    display: "flex",

    left: 0,
    right: 0,
    bottom: 0,

    maxWidth: "100%",
    width: "100%",
    "@media (min-width: 700px)": {
      maxWidth: 1180,
    },
    ...Platform.select({
      ios: {
        top: 0,
        display: "flex",
        flex: 1,
      },
      android: {
        top: 0,
        display: "flex",
        flex: 1,
      },
      web: {
        alignSelf: "center",
      },
    }),
  },
  registerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    flex: 1,
    height: "100%",
    ...Platform.select({
      web: {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
      },
    }),
  },
  loginContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  success: {
    position: "absolute",
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    ...Platform.select({
      ios: {
        top: 90,
      },
      android: {
        top: 70,
      },
      web: {
        top: 70,
      },
    }),
  },
  infoMessage: {
    paddingLeft: theme.spacing.lg,
    color: theme.colors.white,
    fontFamily: theme.fontFamily.robotoRegular,
  },
  infoIcon: {
    width: 13.2,
    height: 13.2,
    position: "absolute",
    top: 3,
  },
  textCenter: {
    textAlign: "center",
  },
  nameBlock: {
    "@media (min-width: 200px)": {
      flexDirection: "column",
    },
    "@media (min-width: 700px)": {
      flexDirection: "row",
    },
  },
  loginLink: {
    alignSelf: "center",
    fontFamily: theme.fontFamily.robotoRegular,
    color: theme.colors.white,
    fontWeight: theme.fontweight.medium as any,
    textAlign: "center",
    ...Platform.select({
      ios: {
        textDecorationLine: "underline",
        textDecorationStyle: "solid",
        textDecorationColor: "#fff",
      },
      android: {
        textDecorationLine: "underline",
        textDecorationStyle: "solid",
        textDecorationColor: "#fff",
      },
      web: {
        textDecoration: "underline",
      },
    }),
  },
  whiteText: {
    color: theme.colors.white,
  },
  loginHere: {
    textAlign: "center",
    justifyContent: "center",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  twoColLayout: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          minWidth: "100%",
          maxWidth: "100%",
          marginTop: 4,
        },
        "@media (min-width: 700px)": {
          minWidth: "50%",
          maxWidth: "50%",
          marginTop: 4,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          minWidth: "100%",
          maxWidth: "100%",
          marginTop: 8,
        },
        "@media (min-width: 700px)": {
          minWidth: "50%",
          maxWidth: "50%",
          marginTop: 8,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          minWidth: "100%",
          maxWidth: "100%",
        },
        "@media (min-width: 700px)": {
          minWidth: "50%",
          maxWidth: "50%",
        },
      },
    }),
  },
  colOne: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingRight: 0,
        },
        "@media (min-width: 600px)": {
          paddingRight: theme.spacing.sm,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingRight: 0,
        },
        "@media (min-width: 600px)": {
          paddingRight: theme.spacing.sm,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          paddingRight: 0,
        },
        "@media (min-width: 600px)": {
          paddingRight: theme.spacing.sm,
        },
      },
    }),
  },
  colTwo: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 600px)": {
          paddingLeft: theme.spacing.sm,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 600px)": {
          paddingLeft: theme.spacing.sm,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 600px)": {
          paddingLeft: theme.spacing.sm,
        },
      },
    }),
  },
  formBlock: {
    // width: "100%",
    maxWidth: 600,
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {},
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          // paddingLeft: 16,
          // paddingRight: 16,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      web: {
        paddingHorizontal: theme.spacing.md,
        width: "100%",
      },
    }),
  },
  formGroup: {
    width: "100%",
    ...Platform.select({
      ios: {
        marginBottom: theme.margin.md,
      },
      android: {
        marginBottom: theme.margin.md,
      },
      web: {
        marginBottom: theme.margin.md,
      },
    }),
  },
  passwordContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  showPassowrd: {
    position: "absolute",
    right: 10,
    // top: 33,
    color: theme.colors.white,
    height: 32,
    // width: 44,
    justifyContent: "center",
    alignItems: "center",
  },
  input: {
    height: 40,
    fontFamily: theme.fontFamily.robotoRegular,
    backgroundColor: theme.colors.white + 20,
    padding: theme.spacing.ssm,
    width: "100%",
    minWidth: "100%",
    paddingRight: 60,
    maxWidth: "100%",
    borderRadius: theme.radius.xxs,
    borderWidth: 0,
    color: theme.colors.white,
  },
  inputRed: {
    height: 40,
    fontFamily: theme.fontFamily.robotoRegular,
    backgroundColor: theme.colors.errorRed + 60,
    padding: theme.spacing.ssm,
    width: "100%",
    minWidth: "100%",
    paddingRight: 60,
    maxWidth: "100%",
    borderRadius: theme.radius.xxs,
    borderWidth: 0,
    color: theme.colors.white,
  },
  inputLabel: {
    textAlign: "left",
    marginBottom: theme.margin.sm,
    color: theme.colors.white,
    fontFamily: theme.fontFamily.robotoRegular,
    fontWeight: theme.fontweight.medium as any,
    fontSize: 18,
  },
  errorContainer: {
    position: "relative",
    marginBottom: 10,
  },
  passwordErrorContainer: {
    position: "relative",
    marginBottom: 0,
  },
  errorMessage: {
    fontFamily: theme.fontFamily.robotoRegular,
    color: theme.colors.errorRed,
    marginTop: 4,
    position: "absolute",
    fontSize: 12,
  },
  hintMessage: {
    color: theme.colors.white,
    fontFamily: theme.fontFamily.robotoRegular,
    marginTop: 4,
    position: "absolute",
    fontSize: 12,
  },
  passwordMessage: {
    color: theme.colors.errorRed,
    fontFamily: theme.fontFamily.robotoRegular,
    marginTop: 4,
    fontSize: 12,
  },
  passwordMessageError: {
    color: theme.colors.white,
    fontFamily: theme.fontFamily.robotoRegular,
    fontSize: 12,
  },
  submitBtn: {
    minWidth: "100%",
    backgroundColor: theme.colors.button.primary,
    padding: 12,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    borderRadius: 10,
    marginTop: 12,
    marginBottom: 24,
    fontWeight: theme.fontweight.medium as any,
  },
  btnText: {
    fontFamily: theme.fontFamily.robotoRegular,
    fontWeight: theme.fontweight.medium as any,
    color: theme.colors.white,
    fontSize: 18,
  },
  heading: {
    width: "100%",
    ...Platform.select({
      ios: {
        marginBottom: 12,
      },
      android: {
        marginBottom: theme.margin.sm,
      },
      web: {
        marginBottom: 30,
        marginTop: 16,
      },
    }),
  },
  headingText: {
    ...Platform.select({
      ios: {
        fontFamily: theme.fontFamily.robotoRegular,
        fontSize: 30,
      },
      android: {
        fontFamily: "RobotoSlab-Bold",
        fontSize: 30,
      },
      web: {
        lineHeight: 1,
        "@media (min-width: 200px)": {
          fontFamily: theme.fontFamily.robotoRegular,
          fontSize: 22,
        },
        "@media (min-width: 700px)": {
          fontFamily: theme.fontFamily.robotoRegular,
          fontSize: 25,
        },
        "@media (min-width: 1150px)": {
          fontFamily: theme.fontFamily.robotoRegular,
          fontSize: 25,
        },
        "@media (min-width: 1681px)": {
          fontFamily: theme.fontFamily.robotoRegular,
          fontSize: 32,
        },
      },
    }),
    fontWeight: "bold",
    fontStyle: "normal",
    letterSpacing: 0,
    textAlign: "left",
    color: theme.colors.white,
  },
  scrollArea: {
    display: "flex",
    ...Platform.select({
      ios: {
        display: "flex",
        flex: 1,
        maxWidth: "100%",
      },
      android: {
        display: "flex",
        flex: 1,
        maxWidth: "100%",
      },
    }),
  },
  logoBlock: {
    marginBottom: 24,
  },
  Logo: {
    width: 200,
    height: 100,
    display: "flex",
    resizeMode: "contain",
    "@media (min-width: 700px)": {
      width: 300,
      height: 120,
    },
  },
  loader: {
    display: "flex",
    flex: 1,
    backgroundColor: theme.colors.black + 50,
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: "110%",
  },
  navigation: {
    elevation: 999,
    zIndex: 999,
  },
});
